import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  titleBlock: {
    id: 'mpf_acoes_block',
    defaultMessage: 'Ações rápidas (capa)',
  },
  title: { id: 'mpf_acoes_title', defaultMessage: 'Título do card' },
  links: { id: 'mpf_acoes_links', defaultMessage: 'Ações' },
  link: { id: 'mpf_acoes_link', defaultMessage: 'Ação' },
  linkLabel: { id: 'mpf_acoes_link_label', defaultMessage: 'Rótulo' },
  linkHref: { id: 'mpf_acoes_link_href', defaultMessage: 'Link' },
  linkHrefHelp: {
    id: 'mpf_acoes_link_href_help',
    defaultMessage:
      'Ao escolher uma página, o rótulo é preenchido com o título dela. Rótulo já editado não é sobrescrito.',
  },
  linkExternal: {
    id: 'mpf_acoes_link_external',
    defaultMessage: 'Abrir em nova aba',
  },
});

const acaoSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.link),
  addMessage: intl.formatMessage(messages.link),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['label', 'href', 'external'],
    },
  ],
  properties: {
    label: { title: intl.formatMessage(messages.linkLabel) },
    href: {
      title: intl.formatMessage(messages.linkHref),
      description: intl.formatMessage(messages.linkHrefHelp),
      widget: 'object_browser',
      mode: 'link',
      selectedItemAttrs: ['@id', '@type', 'Title'],
      allowExternals: true,
      initialPath: '/',
    },
    external: {
      title: intl.formatMessage(messages.linkExternal),
      type: 'boolean',
    },
  },
  required: ['label'],
});

/** Ver `Destaques/schema.ts` sobre `activeObject`/`setActiveObject`. */
export const mpfAcoesRapidasSchema = ({
  intl,
  activeObject,
  setActiveObject,
}: {
  intl: IntlShape;
  activeObject?: number;
  setActiveObject?: (index: number) => void;
}) => ({
  title: intl.formatMessage(messages.titleBlock),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['title', 'links'],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.title),
      placeholder: 'O que você deseja fazer hoje?',
    },
    links: {
      title: intl.formatMessage(messages.links),
      widget: 'object_list',
      schema: acaoSchema({ intl }),
      activeObject,
      setActiveObject,
    },
  },
  required: [],
});

export default mpfAcoesRapidasSchema;
